import { createAction } from 'typesafe-actions';
import { TourSection } from '../types/schema.type';

export const setSection = createAction('setSection', (action) => {
    return (selectedSection: TourSection) => action({ selectedSection });
});
